<template>
  <validation-observer
    v-if="shouldQuestionRender"
    v-show="isRenderAfterFullfilled"
    slim
  >
    <form-section
      id="secondary-telephone"
      no-validity
    >
      <form-row
        :label="title || 'Additional telephone number (optional)'"
        :question="subtitle"
      >
        <template
          v-if="helpText !== false"
          slot="helpText"
        >
          <div
            v-if="helpText"
            v-html="helpText"
          />
        </template>
        <validation-provider
          v-slot="{ errors, failedRules }"
          :vid="`${stepId}_additional-telephone`"
          name="Additional Telephone"
          :rules="rules"
        >
          <qz-text-field
            v-model="questionData.secondaryTelephone"
            :data-test="snakeCase(questionFields.secondaryTelephone)"
            :error-messages="getFieldErrors('secondaryTelephone', failedRules, errors)"
            :maxlength="phoneNumberLimit"
            type="tel"
            autocomplete="tel"
            @keyup="helpers.limitInputChars(questionData, 'secondaryTelephone', phoneNumberLimit)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-secondary-telephone',
  extends: QuestionBase,
  data () {
    return {
      fields: ['secondaryTelephone'],
    };
  },
  computed: {
    rules () {
      const rules = this.validationRules && this.validationRules[this.questionFields.secondaryTelephone];
      const defaultRules = {
        telephone: {
          min: 10,
          max: 12,
          required: false,
        },
      };
      return rules || defaultRules;
    },

    phoneNumberLimit () {
      // Property need to prevent input character collapsing
      const limit = this.inputCharsLimiters.TELEPHONE;
      if (!this.questionData.secondaryTelephone) return limit - 1;
      return this.questionData.secondaryTelephone.indexOf('+44') === 0 ? limit + 2 : limit;
    },
  },
};
</script>
